//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('searchFilterSaveButton', {
    bindings: {
      filterSaveCallback: '&',
      filterSetName: '@',
      filterToastMessage: '@',
    },
    template: require('@legacy-components/filters/search-filter-save-button.html'),
    controller: ['$scope', 'SearchFilterService', 'ToastNotificationService',
      function($scope, SearchFilterService, ToastNotificationService) {
        const self = this;
        let filterState;

        $scope.model = {};

        $scope.model.saveFilters = function() {
          self.filterSaveCallback({ defaultFilters: filterState }).then(() => {
            if (self.filterToastMessage) {
              ToastNotificationService.success({
                title: self.filterToastMessage,
              });
            }
          });
        };

        this.$onInit = function() {
          SearchFilterService.getObservableForFilterSet(self.filterSetName).subscribe((newState) => {
            filterState = newState.setObject;
          });
        };
      },
    ],
  });
})();
